// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React from 'react';

const LegalDisclosure = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem' }}>
    <h1>Legal Disclosures & Terms of Usage</h1>
    <h2>Terms of Usage</h2>
    <p>
      By accessing or using the Just Feasible Solutions application, you agree to be bound by the following terms and conditions. Please read them carefully. If you do not agree with any part of these terms, you must not use this application.
    </p>
    <h3>1. Acceptance of Terms</h3>
    <p>
      Your use of Just Feasible Solutions constitutes your acceptance of these terms. We may update these terms at any time without prior notice. Continued use of the application after changes are posted constitutes your acceptance of the revised terms.
    </p>
    <h3>2. Use of the Application</h3>
    <ul>
      <li>You may use Just Feasible Solutions for lawful business and personal bookkeeping purposes only.</li>
      <li>You are responsible for maintaining the confidentiality of your account and password.</li>
      <li>You agree not to misuse the application, attempt unauthorized access, or disrupt the service.</li>
      <li>All content, features, and functionality are provided "as is" without warranty of any kind.</li>
    </ul>
    <h3>3. Intellectual Property</h3>
    <p>
      All content, trademarks, logos, and software are the property of Just Feasible Solutions LLC or its licensors. You may not copy, modify, distribute, or create derivative works without express written permission.
    </p>
    <h3>4. Limitation of Liability</h3>
    <p>
      To the fullest extent permitted by law, Just Feasible Solutions LLC shall not be liable for any damages arising from your use of or inability to use the application, including but not limited to direct, indirect, incidental, or consequential damages.
    </p>
    <h3>5. User Data & Privacy</h3>
    <p>
      Your use of the application is also governed by our <button type="button" onClick={() => { window.location.hash = ''; window.scrollTo(0,0); }} style={{ background: 'none', border: 'none', padding: 0, color: '#1976d2', cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }}>Privacy Policy</button>.
    </p>
    <h3>6. Termination</h3>
    <p>
      We reserve the right to suspend or terminate your access to the application at any time, for any reason, without notice.
    </p>
    <h3>7. Governing Law</h3>
    <p>
      These terms are governed by the laws of the State of California, United States, without regard to its conflict of law principles.
    </p>
    <h3>8. Contact</h3>
    <p>
      For questions about these legal disclosures or terms of usage, contact us at <a href="mailto:support@justfeasible.com">support@justfeasible.com</a>.
    </p>
    <p style={{ marginTop: 32, color: '#888', fontSize: '0.97rem' }}>
      &copy; 2025 Just Feasible Solutions LLC. All rights reserved.
    </p>
  </div>
);

export default LegalDisclosure;
